import { APIClient } from "api/apiCore";
import * as url from "api/urls";
import LoadingIconWithText from "components/LoadingIconWithText";
import { Utils } from "helpers/utils";
import { useRedux } from "hooks";
import React, { useEffect, useState } from "react";
import { createSelector } from "reselect";

interface WpTagPermReportProps {
  reportPermApiResult: any;
  loadingPerm: boolean;
  onReloadPerm(): void;
}
const WpTagPermReport = ({ reportPermApiResult, loadingPerm, onReloadPerm }: WpTagPermReportProps) => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.Settings,
    (state: any) => state.Profile2,
    (st, p2) => ({
      userConfig: st.userConfig,
      ucLoadUserConfigLoading: st.ucLoadUserConfigLoading,
      isAdmin: p2.isAdmin
    })
  );

  // const [apiGroup, setApiGroup] = useState<any>({});
  const fnGetGroup = (catCodes: string[], groupBy: "COMP" | "DIV" | "DEP" | "POS", data: any) => {
    return Object.values(reportPermApiResult.perms.reduce((acc: any, item: any) => {
      const groupDeep = ["COMP", "DIV", "DEP", "POS"].indexOf(groupBy);
      const companyName = item.CompanyName ?? "N/A";
      const divisionName = item.DivisionName ?? "N/A";
      const departmentName = item.DepartmentName ?? "N/A";
      const positionName = item.PositionName ?? "N/A";
      let keyArray: string[] = [];
      if (groupDeep >= 0) keyArray.push(companyName);
      if (groupDeep >= 1) keyArray.push(divisionName);
      if (groupDeep >= 2) keyArray.push(departmentName);
      if (groupDeep >= 3) keyArray.push(positionName);
      const key = keyArray.join("|");

      if (!acc[key]) {
        acc[key] = { uid: Utils.GetUniqueId() };
        if (groupDeep >= 0) acc[key].CompanyName = companyName;
        if (groupDeep >= 1) acc[key].DivisionName = divisionName;
        if (groupDeep >= 2) acc[key].DepartmentName = departmentName;
        if (groupDeep >= 3) acc[key].PositionName = positionName;
        for (const cat of catCodes) {
          acc[key]['Cnt_' + cat] = 0;
          acc[key]['Ttl_' + cat] = 0;
        }
      }
      for (const cat of catCodes) {
        acc[key]['Cnt_' + cat] += item['Cnt_' + cat];
        acc[key]['Ttl_' + cat] += item['Ttl_' + cat];
      }
      return acc;
    }, {} as Record<string, any>));
  }

  const [permGroup, setPermGroup] = useState<any[]>(); // 0 = Company, 1 = Division, 2 = Department, 3 = Position, 4 = Employee
  const [apiGroup, setApiGroup] = useState<any>({});

  useEffect(() => {
    // console.log('apiResult:', apiResult);
    if (reportPermApiResult) {
      const catCodes = reportPermApiResult.categories.map((x: any) => x.Category);
      const gbCompany = fnGetGroup(catCodes, "COMP", reportPermApiResult);
      const gbDivision = fnGetGroup(catCodes, "DIV", reportPermApiResult);
      const gbDepartment = fnGetGroup(catCodes, "DEP", reportPermApiResult);
      const gbPosition = fnGetGroup(catCodes, "POS", reportPermApiResult);
      // console.log({ catCodes, gbCompany, gbDivision, gbDepartment, gbPosition, apiResult });
      //setPermGroup([gbCompany, gbDivision, gbDepartment, gbPosition, apiResult.perms]);
      setApiGroup({ catCodes, gbCompany, gbDivision, gbDepartment, gbPosition });
    }
  }, [reportPermApiResult]);

  // useEffect(() => {
  //   console.log('permGroup:', permGroup);
  // }, [permGroup]);

  // useEffect(() => {
  //   console.log('apiGroup:', apiGroup);
  // }, [apiGroup]);

  const colors = [
    '#8CFF8C',
    '#7EF482',
    '#70E978',
    '#62DE6D',
    '#54D363',
    '#46C858',
    '#38BD4E',
    '#2AB244',
    '#1CA739',
    '#0E9C2F',
    '#009124',
  ];

  const PermComponent = (obj: any, category: string) => {
    // console.log('PermComponent:', obj);
    const total = Utils.ToNumber(obj['Ttl_' + category], 0)!;
    const has = Utils.ToNumber(obj['Cnt_' + category], 0)!;
    const pcnt = total == 0 ? 0 : (has / total * 100.0);
    const index = Math.round(pcnt / 10.0)
    const color = index > 0 ? colors[index] : (pcnt > 0 ? colors[0] : "gray");
    const icon = (index > 0 || pcnt > 0) ? "fas fa-check-circle" : "far fa-times-circle";
    return (
      <div title={Utils.FormatNumber(pcnt, 2)}>
        <i className={icon} style={{ color: color }} ></i>
        {/* {index} */}
      </div>
    );
  }

  const onClickExpand = (level: number, uid: string) => {
    setApiGroup((prev: any) => {
      const toggleExpand = (arr: any[]) => arr.map((item) => item.uid === uid ? { ...item, Expand: !item.Expand } : item);

      return {
        ...prev,
        gbCompany: level === 0 ? toggleExpand(prev.gbCompany) : prev.gbCompany,
        gbDivision: level === 1 ? toggleExpand(prev.gbDivision) : prev.gbDivision,
        gbDepartment: level === 2 ? toggleExpand(prev.gbDepartment) : prev.gbDepartment,
        gbPosition: level === 3 ? toggleExpand(prev.gbPosition) : prev.gbPosition,
      };
    });
  };

  const genTr = (key: any, level04: number, caption: string, rowData: any, childCount: number): React.ReactNode => {
    const icon = [
      'fa fa-building',
      'fa fa-sitemap',
      'fa fa-layer-group',
      'fa fa-user-tag',
      'fa fa-user'
    ][level04];
    // const thBg = [
    //   '#B8B8DC',
    //   '#C9C9E4',
    //   '#DBDBED',
    //   '#EDEDF6',
    //   '#FFFFFF',
    // ][level04];
    const thBg = [
      '#B8B8DC',
      '#C9C9E4',
      '#DBDBED',
      '#EDEDF6',
      '#FFFFFF',
    ][level04];
    const pl = 2 + (level04 * 20);
    const expanded = rowData.Expand == true ? true : false;
    const expcss = expanded ? "fas fa-angle-double-up" : "fas fa-angle-double-down";
    if (caption.trim() == "") caption = "ไม่ระบุ";
    return (
      <tr key={key} className="hover hand text-black" style={{ backgroundColor: thBg }}>
        <td style={{ paddingLeft: pl, backgroundColor: thBg, minWidth: "300px", maxWidth: "300px" }} className="hand" onClick={(e) => childCount > 0 ? onClickExpand(level04, rowData.uid) : undefined}>
          <div className="d-flex justify-content-between align-items-center no-wrap" style={{ overflow: "hidden" }}>
            <span><i className={"fz-08 me-1 " + icon}></i>{caption}</span>
            {childCount > 0 && (<i className={expcss}></i>)}
          </div>
        </td>
        {reportPermApiResult?.categories.map((x: any) => (<td align="center" onClick={(e) => childCount > 0 ? onClickExpand(level04, rowData.uid) : undefined}>{PermComponent(rowData, x.Category)}</td>))}
      </tr>
    );
  }

  return (
    <>
      <div className="d-flex justify-content-between w-100">
        <div><span>สิทธิ์ที่แสดงในนี้ มาจากการตั้งสิทธิ์การเห็น tag หรือการเข้าไปเกี่ยวข้องในโพสต่าง ๆ</span></div>
        <div>
          <button className="btn2 btn2-outline-primary" onClick={loadingPerm ? undefined : onReloadPerm}>
            {loadingPerm && (<LoadingIconWithText loadingText={""} />)}
            Refresh
          </button>
        </div>
      </div>
      <div className="div-table-fix-header div-table-fix-first-col" style={{ height: "calc(100vh - 120px)" }}>
        <table>
          <thead>
            <tr>
              <th style={{ minWidth: "300px", maxWidth: "300px" }}><span className="no-wrap"><i className="fa fa-group fz-08 me-1"></i>ผังองค์กร</span></th>
              {reportPermApiResult?.categories.map((x: any) => (
                <th style={{ backgroundColor: x.BgColor, color: x.FaColor }}>
                  <span className="no-wrap"><i className={x.FaIcon + " fz-08 me-1"}></i>{x.Name}</span>
                </th>))}
            </tr>
          </thead>
          <tbody>
            {/* company rows */}
            {apiGroup?.gbCompany?.map((comp: any, idxComp: number) => {
              const keyComp = comp.CompanyName + idxComp.toString();
              const divisions = apiGroup?.gbDivision?.filter((x: any) => x.CompanyName == comp.CompanyName);
              return (
                <React.Fragment key={`${keyComp} `}>
                  {genTr(`tr - ${keyComp} `, 0, comp.CompanyName, comp, divisions.length)}

                  {/* division rows */}
                  {comp.Expand && divisions.map((div: any, idxDiv: number) => {
                    const divCode = keyComp + '|' + div.DivisionName + idxDiv.toString();
                    const departments = apiGroup?.gbDepartment?.filter((x: any) => x.CompanyName == comp.CompanyName && x.DivisionName == div.DivisionName);
                    return (
                      <>
                        {genTr(`tr - ${divCode} `, 1, div.DivisionName, div, departments.length)}

                        {/* department row */}
                        {div.Expand && departments.map((dep: any, idxDep: number) => {
                          const depCode = divCode + '|' + dep.DepartmentName + idxDep.toString();
                          const positions = apiGroup?.gbPosition?.filter((x: any) => x.CompanyName == comp.CompanyName && x.DivisionName == div.DivisionName && x.DepartmentName == dep.DepartmentName);
                          return (
                            <>
                              {genTr(`tr - ${depCode} `, 2, dep.DepartmentName, dep, positions.length)}

                              {/* position rows */}
                              {dep.Expand && positions.map((pos: any, idxPos: number) => {
                                const posCode = depCode + '|' + pos.PositionName + idxPos.toString();
                                const employees = reportPermApiResult?.perms?.filter((x: any) => x.CompanyName == comp.CompanyName && x.DivisionName == div.DivisionName && x.DepartmentName == dep.DepartmentName && x.PositionName == pos.PositionName);
                                return (
                                  <>
                                    {genTr(`tr - ${posCode} `, 3, pos.PositionName, pos, employees.length)}

                                    {/* employee rows */}
                                    {pos.Expand && employees.map((emp: any, idxEmp: number) => {
                                      const empCode = posCode + '|' + emp.UserId;
                                      return (
                                        <>
                                          {genTr(`tr - ${empCode} `, 4, emp.DisplayName2, emp, 0)}
                                        </>
                                      )
                                    })}
                                  </>
                                )
                              })}
                            </>
                          )
                        })}
                      </>
                    )
                  })}
                </React.Fragment>
              )
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default WpTagPermReport;
